import { Route } from "react-router-dom";
import Tools from "@pages/tools";
import MyFiles from "@pages/tools/my-files-view";
import EdlinkTeacherClasses from "@pages/tools/edlink-teacher-classes-view";
import EssayGrading from "@pages/essay-grading";
import SuperTool from "@pages/super-tool";

export const toolRoutes = [
  <Route key="tools" path="/content/tools" element={<Tools />} />,
  <Route key="files" path="/files" element={<MyFiles />} />,
  <Route key="edlink" path="/edlink" element={<EdlinkTeacherClasses />} />,
  <Route
    key="essay-grading"
    path="/essay-grading"
    element={<EssayGrading />}
  />,
  <Route key="super-tool" path="/super-tool/*" element={<SuperTool />} />,
];
